(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ax-cart-suggest"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ax-sg-picker')){
    customElements.define('ax-sg-picker',class extends HTMLElement{
      static busy=false;
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        this.addEventListener('click',event=>{
          const button=event.target.closest('.ax-sg__btn');
          if(button)this.addMask(button);
        });
      }
      async addMask(button){
        if(this.constructor.busy)return;
        const picked=this.querySelector('input[type="radio"]:checked')||this.querySelector('input[type="radio"]');
        if(!picked)return;
        this.constructor.busy=true;
        button.disabled=true;
        const feedback=this.querySelector('.ax-sg__fb');
        feedback.hidden=true;
        let added=false;
        try{
          const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(picked.value),quantity:1}]})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||this.dataset.error);
          added=true;
          const cartResponse=await fetch(this.dataset.cartUrl+'.js');
          if(!cartResponse.ok)throw new Error(this.dataset.error);
          const cart=await cartResponse.json();
          if(this.closest('.ax-cart')){window.location.assign(this.dataset.cartUrl);return;}
          document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ax-sg-picker',data:{itemCount:cart.item_count,source:'ax-sg-picker'}}}));
        }catch(error){
          if(added){window.location.assign(this.dataset.cartUrl);return;}
          feedback.textContent=error.message||this.dataset.error;
          feedback.hidden=false;
          button.disabled=false;
        }finally{
          this.constructor.busy=false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ax-free-ship"] && !Shopify.designMode) return;
  try {
    (function(){
    if(window.__axFsInit) return;
    window.__axFsInit=true;
    var last=null;
    var calm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setup(){
      var list=document.querySelectorAll('[data-ax-fs]');
      Array.prototype.forEach.call(list,function(el){
        var p=el.getAttribute('data-p');
        if(!el.__axFs){
          el.__axFs=true;
          if(!calm&&last!==null&&last!==p){
            el.style.setProperty('--p',last+'%');
            requestAnimationFrame(function(){requestAnimationFrame(function(){el.style.setProperty('--p',p+'%');});});
          }
        }
        last=p;
      });
    }
    if(window.MutationObserver){
      new MutationObserver(setup).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['data-p']});
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup); else setup();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ax-pdp-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ax-pdp-gallery')) {
  customElements.define('ax-pdp-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.axg__track');
      this.slides = [...this.querySelectorAll('.axg__slide')];
      this.dots = [...this.querySelectorAll('[data-axg-dot]')];
      if (!this.track || this.abort) return;
      this.abort = new AbortController();
      const o = { signal: this.abort.signal };
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => {
        const s = this.slides[i];
        if (s) this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }, o));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.sync());
      }, { ...o, passive: true });
    }
    sync() {
      const left = this.track.scrollLeft;
      let idx = 0, best = Infinity;
      this.slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left);
        if (d < best) { best = d; idx = i; }
      });
      if (left + this.track.clientWidth >= this.track.scrollWidth - 2) idx = this.slides.length - 1;
      this.dots.forEach((d, i) => i === idx ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'));
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; cancelAnimationFrame(this.raf); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ax-pdp-suggest"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ax-ps')){
    customElements.define('ax-ps',class extends HTMLElement{
      static busy=false;
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        this.addEventListener('click',event=>{
          const button=event.target.closest('[data-ps-add]');
          if(button)this.add(button);
        });
        document.addEventListener('cart:update',()=>this.sync());
        window.addEventListener('pageshow',()=>this.sync());
        this.sync();
      }
      async sync(){
        try{
          const cart=await (await fetch(this.dataset.cartUrl,{cache:'no-store'})).json();
          const row=this.querySelector('[data-ps-row="pair"]');
          if(!row)return;
          const button=row.querySelector('[data-ps-add]');
          if(!button)return;
          if(!button.dataset.label)button.dataset.label=button.textContent;
          const packed=cart.items.some(item=>String(item.variant_id)===row.dataset.ids&&item.quantity>0);
          button.disabled=packed;
          button.textContent=packed?this.dataset.added:button.dataset.label;
        }catch(error){}
      }
      async add(button){
        if(this.constructor.busy)return;
        const row=button.closest('[data-ps-row]');
        let items;
        if(row.dataset.psRow==='pair'){
          items=[{id:Number(row.dataset.ids),quantity:1}];
        }else{
          const picked=row.querySelector('input[type="radio"]:checked')||row.querySelector('input[type="radio"]');
          if(!picked)return;
          const primary=Number(row.dataset.primary),second=Number(picked.value);
          items=primary===second?[{id:primary,quantity:2}]:[{id:primary,quantity:1},{id:second,quantity:1}];
        }
        this.constructor.busy=true;
        button.disabled=true;
        const feedback=this.querySelector('.ax-ps__fb');
        feedback.hidden=true;
        let added=false;
        try{
          const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||this.dataset.error);
          added=true;
          const cart=await (await fetch(this.dataset.cartUrl,{cache:'no-store'})).json();
          document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ax-ps',data:{itemCount:cart.item_count,source:'axpp-pair'}}}));
        }catch(error){
          if(!added){feedback.textContent=error.message||this.dataset.error;feedback.hidden=false;}
        }finally{
          this.constructor.busy=false;
          if(row.dataset.psRow!=='pair')button.disabled=false;
          else if(!added)button.disabled=false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ax-plus-one-mini"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ax-duo-picker')){
    customElements.define('ax-duo-picker',class extends HTMLElement{
      static busy=false;
      connectedCallback(){
        if(this.initialized)return;
        this.initialized=true;
        const initialButton=this.querySelector('.ax-duo__add');
        if(initialButton)this.originalLabel=initialButton.textContent;
        this.addEventListener('change',()=>{
          if(this.constructor.busy)return;
          const button=this.querySelector('.ax-duo__add');
          if(button){button.disabled=false;button.textContent=this.originalLabel;}
          const feedback=this.querySelector('.ax-duo__feedback');
          if(feedback)feedback.hidden=true;
        });
        this.addEventListener('click',event=>{
          const button=event.target.closest('.ax-duo__add');
          if(button)this.addMask(button);
        });
      }
      async addMask(button){
        if(this.constructor.busy)return;
        const picked=this.querySelector('input[type="radio"]:checked')||this.querySelector('input[type="radio"]');
        if(!picked)return;
        this.constructor.busy=true;
        button.disabled=true;
        const feedback=this.querySelector('.ax-duo__feedback');
        feedback.hidden=true;
        const second=Number(picked.value);
        const primary=Number(this.dataset.primary);
        let items=[{id:second,quantity:1}];
        if(this.dataset.context==='collection'){
          const first=this.querySelector('[data-duo-slot="1"] input:checked');
          const last=this.querySelector('[data-duo-slot="2"] input:checked');
          if(!first||!last){button.disabled=false;this.constructor.busy=false;return;}
          const a=Number(first.value),b=Number(last.value);
          items=a===b?[{id:a,quantity:2}]:[{id:a,quantity:1},{id:b,quantity:1}];
        }
        if(this.dataset.context==='product'){
          items=primary===second?[{id:primary,quantity:2}]:[{id:primary,quantity:1},{id:second,quantity:1}];
        }
        let added=false;
        try{
          const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||this.dataset.error);
          added=true;
          const cartResponse=await fetch(this.dataset.cartUrl+'.js');
          if(!cartResponse.ok)throw new Error(this.dataset.error);
          const cart=await cartResponse.json();
          const cartPage=this.closest('.ax-cart');
          if(cartPage){window.location.assign(this.dataset.cartUrl);return;}
          button.textContent=this.dataset.added;
          document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'ax-duo-picker',data:{itemCount:cart.item_count,source:'ax-duo-picker'}}}));
          const drawer=document.querySelector('cart-drawer-component');
          if(drawer&&typeof drawer.open==='function')drawer.open();
          else window.location.assign(this.dataset.cartUrl);
        }catch(error){
          if(added){window.location.assign(this.dataset.cartUrl);return;}
          feedback.textContent=error.message||this.dataset.error;
          feedback.hidden=false;
          button.disabled=false;
        }finally{
          this.constructor.busy=false;
          button.disabled=false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
